<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table">
      <tr class="title p-1 w-full">
        <th :colspan="getColspan">DADOS DO VEÍCULO</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Veículo 0 km?</b>
          {{ quotationData.vehicle.is_brand_new ? 'Sim' : 'Não' }}
        </td>
        <td class="pl-3"><b>Chassi</b>: {{ quotationData.vehicle.chassis }}</td>
        <div v-if="!isQuotation">
          <td
            class="pl-3"
            v-if="
              quotationData.vehicle.is_brand_new &&
              quotationData.vehicle.invoice_number
            "
          >
            <b>Número da NF</b>: {{ quotationData.vehicle.invoice_number }}
          </td>
          <td
            class="pl-3"
            v-if="
              quotationData.vehicle.is_brand_new &&
              quotationData.vehicle.invoice_number
            "
          >
            <b>Data da NF</b>: {{ quotationData.vehicle.invoice_date }}
          </td>
        </div>
        <td class="pl-3"><b>Placa</b>: {{ quotationData.vehicle.plate }}</td>
      </tr>
      <tr>
        <td class="pl-3"><b>Marca</b>: {{ quotationData.vehicle.brand }}</td>
        <td class="pl-3"><b>Modelo</b>: {{ quotationData.vehicle.model }}</td>
        <td class="pl-3">
          <b>Ano Modelo</b>:
          {{
            quotationData.vehicle.year_model === 32000
              ? '0Km'
              : quotationData.vehicle.year_model
          }}
        </td>
        <td class="pl-3">
          <b>Código da Fipe</b>: {{ quotationData.vehicle.fipe_code }}
        </td>
        <td
          class="pl-3"
          v-if="
            quotationData.vehicle.is_brand_new && quotationData.vehicle.plate
          "
        ></td>
      </tr>
      <tr v-if="isQuotation">
        <td
          class="pl-3"
          v-if="
            quotationData.vehicle.is_brand_new &&
            quotationData.vehicle.invoice_number
          "
        >
          <b>Número da NF</b>: {{ quotationData.vehicle.invoice_number }}
        </td>
        <td
          class="pl-3"
          v-if="
            quotationData.vehicle.is_brand_new &&
            quotationData.vehicle.invoice_number
          "
        >
          <b>Data da NF</b>: {{ quotationData.vehicle.invoice_date }}
        </td>
        <td v-if="quotationData.vehicle.is_brand_new" class="pl-3">
          <b>Veículo saiu da concessionária?</b>
          {{ quotationData.vehicle.out_daelership ? 'Sim' : 'Não' }}
        </td>
        <td
          v-if="
            quotationData.vehicle.is_brand_new &&
            quotationData.vehicle.dealership_exit_date
          "
          class="pl-3"
        >
          <b>Data de saída da concessionária</b>:
          {{
            functions.formataDataHoraPadraoBR(
              quotationData.vehicle.dealership_exit_date,
              false,
            )
          }}
        </td>
        <td></td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.VEHICLE"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.VEHICLE"
    ></div>
  </vx-card>
</template>

<script>
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractVehicle',
  props: {
    isQuotation: {
      type: Boolean,
      required: false,
      default: false,
    },
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
    };
  },
  computed: {
    getColspan() {
      return this.quotationData.vehicle.is_brand_new ? 5 : 4;
    },
  },
};
</script>
